document.addEventListener('DOMContentLoaded', function () {
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  if (!productForms.length) return;

  productForms.forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      const submitter = event.submitter;

      if (
        submitter &&
        submitter.name &&
        submitter.name === 'checkout'
      ) {
        return;
      }

      event.preventDefault();

      const accessoriesContainer = document.querySelector('[data-product-accessories]');
      const checkedAccessories = accessoriesContainer ? accessoriesContainer.querySelectorAll(
        'input[data-accessory-variant-id]:checked'
      ) : [];

      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);

      if (!mainVariantId) {
        console.error('Keine Hauptvariante gefunden.');
        return;
      }

      const properties = {};
      formData.forEach((value, key) => {
        if (key.startsWith('properties[')) {
          const propName = key.match(/^properties\[(.+)\]$/)[1];
          properties[propName] = value;
        }
      });

      const mainItem = {
        id: parseInt(mainVariantId, 10),
        quantity: quantity
      };

      if (Object.keys(properties).length > 0) {
        mainItem.properties = properties;
      }

      const items = [mainItem];

      checkedAccessories.forEach(function (checkbox) {
        const accessoryVariantId = checkbox.getAttribute('data-accessory-variant-id');

        if (accessoryVariantId) {
          items.push({
            id: parseInt(accessoryVariantId, 10),
            quantity: 1
          });
        }
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          throw new Error('Fehler beim Hinzufügen zum Warenkorb.');
        }

        showAddedMessage();

        const cartDrawerTrigger =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartDrawerTrigger && typeof cartDrawerTrigger.renderContents === 'function') {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          cartDrawerTrigger.renderContents(cartData);
        }
      } catch (error) {
        console.error(error);
      }
    });
  });

  function showAddedMessage() {
    const existingMessage = document.querySelector('[data-product-added-message]');
    if (existingMessage) {
      existingMessage.remove();
    }

    const toast = document.createElement('div');
    toast.setAttribute('data-product-added-message', '');
    toast.className = 'product-added-toast';
    toast.innerHTML = `
      <span class="product-added-toast__icon">✓</span>
      <span class="product-added-toast__text">Produkt wurde dem Warenkorb hinzugefügt</span>
    `;

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('product-added-toast--visible');
    });

    setTimeout(function() {
      toast.classList.remove('product-added-toast--visible');
      setTimeout(function() {
        toast.remove();
      }, 300);
    }, 3000);
  }
});